module.exports = __webpack_public_path__ + "img/zizhi5.0c129128.png";